import React from 'react';
import TypeClassLightCardProps, { TypeImageProps } from "./props";
import style from "./style.module.scss";
import classNames from '../../../utils/classNames';
import Title from '../../private/Title';
import TitleProps from '../../private/Title/props';
import Content from '../../private/Content';
import ContentProps from '../../private/Content/props';
import Picture from '../../private/Picture';
import { PictureProps } from '../../private/Picture/props';
import config from './config.json';
import LinkContainer from '../../private/LinkContainer';

function TypeClassLightCard(props: TypeClassLightCardProps) {
  return (
    <LinkContainer hyperlinkAttributes={{ href: props.link?.url, ...props.link?.hyperlinkAttributes }}>
      <div className={ classNames('typeClassLightCard', style, {}) }>
        <Picture { ...useImageProps(props.image) } />
        <div className={classNames('typeClassLightCardTextContainer', style)}>
          <Title { ...useTitleProps(props) } />
          <Content { ...useContentProps(props) } />
        </div>
      </div>
    </LinkContainer>
  );
}

const useImageProps = (props: TypeImageProps): PictureProps => ({
  ...props,
  mainImgClassNames: config.Picture.classNames,
});

const useTitleProps = (props: TypeClassLightCardProps): TitleProps => ({
  text: props.title,
  classNames: config.Title.classNames,
});

const useContentProps = (props: TypeClassLightCardProps): ContentProps => ({
  text: props.description,
  classNames: config.Content.classNames,
});


export default React.memo(TypeClassLightCard);